const spendingLimits = {
  'spendingLimits.channels': 'Domestic Channels',
  'spendingLimits.channels.Domestic': 'Domestic Channels',
  'spendingLimits.channels.International': 'International Channels',
  'spendingLimits.channels.MasterChannels': 'Account limits',
  'spendingLimits.channels.Supplementary': 'Master Channel Controls',
  'spendingLimits.errorChangeChannel': 'Channel update error',
  'spendingLimits.value': 'Limit value',
  'spendingLimits.confirm': 'Confirm',
  'spendingLimits.limitValueUpdateSuccess': 'Limit value updated!',
  'spendingLimits.resetIn': 'Reset in',
  'spendingLimits.channels.infoMessage':
    'Please disable channel if you  not  wish to use this  channel',
};

export default spendingLimits;
